import React from "react";

const defaultConflictRows = [
  {
    label:
      "Number of complaints received in relation to issues of Conflict of Interest of the Directors",
    currentNumber: "",
    currentRemarks: "",
    previousNumber: "",
    previousRemarks: "",
  },
  {
    label:
      "Number of complaints received in relation to issues of Conflict of Interest of the KMPs",
    currentNumber: "",
    currentRemarks: "",
    previousNumber: "",
    previousRemarks: "",
  },
];

const ConflictOfInterestTable = ({ conflictData, setConflictData }) => {
  const handleChange = (index, field, value) => {
    const updated = [...conflictData];
    updated[index][field] = value;
    setConflictData(updated);
  };

  return (
    <div
      style={{
        marginTop: "20px",
        overflowX: "auto",
        border: "1px solid #000",
        borderRadius: "8px",
        overflow: "hidden",
      }}
    >
      <table
        style={{
          width: "100%",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th rowSpan="2" style={tableHeaderStyle}>
              Description
            </th>
            <th colSpan="2" style={tableHeaderStyle}>
              Current Financial Year
            </th>
            <th colSpan="2" style={tableHeaderStyle}>
              Previous Financial Year
            </th>
          </tr>
          <tr style={{ backgroundColor: "#D3C9CE", fontWeight: "bold" }}>
            <th style={tableHeaderStyle}>Number</th>
            <th style={tableHeaderStyle}>Remarks</th>
            <th style={tableHeaderStyle}>Number</th>
            <th style={tableHeaderStyle}>Remarks</th>
          </tr>
        </thead>
        <tbody>
          {conflictData.map((row, index) => (
            <tr key={index}>
              <td style={{ ...tableCellStyle, fontWeight: "bold" }}>
                {row.label}
              </td>

              <td style={tableCellStyle}>
                <input
                  type="number"
                  placeholder="Total Number"
                  value={row.currentNumber}
                  onChange={(e) =>
                    handleChange(index, "currentNumber", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>

              <td style={tableCellStyle}>
                <textarea
                  placeholder="Remarks"
                  value={row.currentRemarks}
                  onChange={(e) =>
                    handleChange(index, "currentRemarks", e.target.value)
                  }
                  style={textareaStyle}
                />
              </td>

              <td style={tableCellStyle}>
                <input
                  type="number"
                  placeholder="Total Number"
                  value={row.previousNumber}
                  onChange={(e) =>
                    handleChange(index, "previousNumber", e.target.value)
                  }
                  style={inputStyle}
                />
              </td>

              <td style={tableCellStyle}>
                <textarea
                  placeholder="Remarks"
                  value={row.previousRemarks}
                  onChange={(e) =>
                    handleChange(index, "previousRemarks", e.target.value)
                  }
                  style={textareaStyle}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Styles
const tableHeaderStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
};

const tableCellStyle = {
  padding: "10px",
  border: "1px solid #000",
  textAlign: "center",
  verticalAlign: "middle",
};

const inputStyle = {
  width: "100%",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "14px",
  textAlign: "center",
  backgroundColor: "white",
  outline: "none",
};

const textareaStyle = {
  width: "100%",
  height: "80px",
  padding: "6px",
  borderRadius: "4px",
  border: "1px solid grey",
  fontSize: "14px",
  backgroundColor: "white",
  outline: "none",
  resize: "vertical",
};

export default ConflictOfInterestTable;
